import { useLayoutEffect, useRef, type ReactNode } from 'react';

/** Native <dialog> modālais logs; tiek renderēts tikai tad, kad ir atvērts. Esc → onClose. */
export function Modal(p: { onClose: () => void; className?: string; label?: string; children: ReactNode; testId?: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  useLayoutEffect(() => {
    const d = ref.current!;
    if (!d.open) d.showModal();
    return () => {
      if (d.open) d.close();
    };
  }, []);
  return (
    <dialog
      ref={ref}
      className={p.className}
      aria-label={p.label}
      data-testid={p.testId}
      onCancel={(e) => {
        e.preventDefault();
        p.onClose();
      }}
    >
      {p.children}
    </dialog>
  );
}
